import React, { Component } from 'react';
import { Picker, List, Toast, InputItem } from 'antd-mobile';
import * as services from '../projects/services';
import './style.less';
import { Button } from 'antd';
export class AddPeople extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            marriagelist: [],
            Marital: 0,
            peoplelist: [],
            baglist: [],
            Bagid: 0,
            fname: !!this.props.data.peopleid ? '修改体检人信息' : '添加体检人',
            Fullname: '',
            Mobile: '',
            Idnumber: '',
            PeopleId: this.props.data.peopleid,
        }
        this.onBaglist = this.onBaglist.bind(this);
        this.onMarriage = this.onMarriage.bind(this);
    }
    componentDidMount() {
        if(!!this.state.PeopleId)
        {
            let data=this.state.data;
            let cMarital=[];
            cMarital.push(data.maritalstatus+"");
            let cBagid=[];
            cBagid.push(data.bagid+"");
            this.setState({
                PeopleId: data.peopleid,
                Bagid: cBagid, Marital: cMarital, Fullname:!!data.fullname?data.fullname:data.createman,
                Idnumber: data.idnumber, Mobile: data.mobile,
            });           
        }   
        services.GetPeopleList(null,'').then(data => {
            if (data.status === 0) {
                this.setState({ peoplelist: data.result });
                let oneself = data.result.find((p) => parseInt(p.bagid) === 1);
                services.GetList('体检人标签', '').then(data2 => {
                    if (data2.status === 0) {
                        if (!!data2.result) {
                            let baglist = [];
                            if (!!oneself) {
                                baglist = data2.result.filter((p) => parseInt(p.code) !== 1);
                            } else {
                                baglist = data2.result;
                            }
                            const arr1 = baglist.map(function (item) {
                                let obj = {};
                                obj.value = item.code;
                                obj.label = item.name;
                                return obj
                            })                          
                            this.setState({ baglist: arr1});
                        }

                    } else {
                        Toast.offline(data2.message);
                    }
                })

            } else {
                Toast.offline(data.message);
            }
        })
        services.GetList('适用婚姻状况', '').then(data3 => {
            if (data3.status === 0) {
                let cm = [];
                data3.result.forEach((element, index) => {
                    if (index !== 0) {
                        element.name = element.name.substring(2, element.name.length);
                        let obj = {};
                        obj.value = element.code;
                        obj.label = element.name;
                        cm.push(obj);
                    }
                });

                this.setState({ marriagelist: cm });
            } else {
                Toast.offline(data3.message);
            }
        })     


    }
    onClose = () => { // 学习挣钱，调用父组件方法       
        this.props.onClose();
      
    }
    handleInputChange(ename, event) {
        this.setState({ [ename]: event });
    }
    onBaglist = (e) => {
        if (Array.isArray(e)) {
            this.setState({ Bagid: e });
        } else {
            let cm = [];
            cm.push(e);
            this.setState({ Bagid: cm });
        }
    }
    onMarriage = (e) => {
        if (Array.isArray(e)) {
            this.setState({ Marital: e });
        } else {
            let cm = [];
            cm.push(e);
            this.setState({ Marital: cm });
        }
    }
    verification = () => {
        var idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
        var regex = /^1\d{10}$/;
        if (!this.state.Fullname) {
            Toast.offline('体检人姓名不能为空', 2);
            return false;
        }
        if (!this.state.Idnumber || !idcardReg.test(this.state.Idnumber)) {
            Toast.info('身份证号码输入有误，请重新输入！', 1);
            return false;
        } if (!this.state.Mobile || !regex.test(this.state.Mobile)) {
            Toast.info('电话号码输入错误，请重新输入！', 1);
            return false;
        }
        if (!this.state.Bagid || this.state.Bagid === 0) {
            Toast.info('请选择与体检人关系！', 1);
            return false;
        }
        if (!this.state.Marital || this.state.Marital === 0) {
            Toast.info('请选择体检人结婚状态！', 1);
            return false;
        }
        return true;
    }
    addPeople = () => {
        if (!this.verification()) {
            return false;
        }
        let parameter = {
            Bagid: this.state.Bagid[0],
            Marital: this.state.Marital[0],
            Fullname: this.state.Fullname,
            Idnumber: this.state.Idnumber,
            Mobile: this.state.Mobile,
        }
      
        if (this.state.data.length === 0) {
            
            services.AddPeople(parameter, '正在添加请稍后').then(data => {
                if (data.status === 0) {
                    Toast.success(data.message);
                   this.props.onClose();
                } else {
                    Toast.success(data.message);
                }
            });
        }else{
            parameter.PeopleId = this.state.PeopleId;
            services.EditPeople(parameter, '正在修改请稍后').then(data => {
                if (data.status === 0) {
                    Toast.success(data.message);
                    this.props.onClose();
                } else {
                    Toast.success(data.message);
                }
            });
        }

    }
    render() {
        const { baglist, Fullname, Idnumber, Mobile, Bagid, marriagelist, Marital } = this.state;
        return <div className="addaddress">
            <List renderHeader={() => this.state.fname}>
                <InputItem
                    clear
                    placeholder="体检人姓名" name="Fullname" value={Fullname} onChange={this.handleInputChange.bind(this, 'Fullname')}
                    ref={el => this.FullnameRef = el}
                >姓名</InputItem>
                <InputItem
                    clear name="Idnumber"
                    placeholder="体检人身份证" value={Idnumber} onChange={this.handleInputChange.bind(this, 'Idnumber')}

                >身份证</InputItem>
                <InputItem
                    clear name="Mobile"
                    placeholder="体检人手机号码" value={Mobile} onChange={this.handleInputChange.bind(this, 'Mobile')}
                >手机号码</InputItem>
                {
                    !!this.props.data.peopleid && this.state.data.bagid === 1 ?              
               ''
                :
                <Picker
                    data={baglist}
                    value={Bagid}
                    cols={1}
                    onChange={this.onBaglist}
                >
                    <List.Item arrow="horizontal"  >关系</List.Item>
                </Picker>
                  }
                <Picker
                    data={marriagelist}
                    value={Marital}
                    cols={1}
                    onChange={this.onMarriage}                >
                    <List.Item arrow="horizontal"  >婚否</List.Item>
                </Picker>
            </List>
            <div className="footBut">
                <Button onClick={this.onClose}  >取消</Button><Button className="ant-btn2" onClick={this.addPeople} >确定</Button>
            </div>
        </div>
    }
}